export const regexp = '[a-zA-Z0-9!@#$&()-`.+,/"]{6,}'
